import { ChangeCompanyStateComponent } from "./change-company-state.component";
export const ChangeCompanyStateModule = angular
    .module('changeCompanyState', [])
    .component(ChangeCompanyStateComponent.selector, ChangeCompanyStateComponent.component)
    .name;
//# sourceMappingURL=change-company-state.module.js.map